import React from 'react';
interface TestimonialCardProps {
  quote: string;
  author: string;
}
export const TestimonialCard = ({
  quote,
  author
}: TestimonialCardProps) => {
  return <div className="bg-green-50 border-l-4 border-green-500 p-5 rounded-lg mb-6" data-id="element-143">
      <p className="font-semibold mb-2" data-id="element-144">- {author}</p>
      <p className="text-lg md:text-xl italic" data-id="element-145">"{quote}"</p>
    </div>;
};